import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSessionExpiryWatcher } from './apiClient';

// Must run once, before anything renders — patches window.fetch/axios so an expired JWT on
// ANY request (not just the ones AuthContext itself makes) triggers a redirect to login.
initSessionExpiryWatcher();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
